import React from 'react';
import {actions, ErrorMessage, InputTypeField, TextField, SelectField} from "react-fields";
import CountriesAPI from "../../components/api/countriesApi";
import PopUp from "../base/popup";
import EmailForm from "./changeEmailForm";
import PasswordForm from './changePasswordForm';
import HoverButton from "../buttons/HoverButton";
import EducatorValidation from './validation';
import userAPI from '../api/educatorAPI';
import Checkbox from "../base/checkbox";
import BaseFunc from "../base/baseFunctions";
import {FadeInSection} from "../../components/fadeIn";

class Form extends React.Component {

    state = {
        educator: {...this.props.educator, errors: {}},
        needValidateVat: false,
        vatOptions: {vat_number: this.props.educator.vat_number, country_id: this.props.educator.country_id},
        countries: []
    };

    changeEmailPopup = React.createRef();
    changePasswordPopup = React.createRef();
    successPopup = React.createRef();

    componentDidMount() {
        CountriesAPI.getCollection({}).then((response) => {
            const currentCountry = response.find((c) => c.id === parseInt(this.state.educator.country_id));
            this.setState({countries: response, needValidateVat: (currentCountry && currentCountry.eu_vat)})
        }).catch(error => {
            console.log(error);
        });
    }

    validateVat = () => {
        if (this.state.needValidateVat && (this.state.educator.country_id !== this.state.vatOptions.country_id || this.state.educator.vat_number !== this.state.vatOptions.vat_number)) {
            const vatOptions = {vat_number: this.state.educator.vat_number, country_id: this.state.educator.country_id};
            userAPI.validateVat(vatOptions, (result) => {
                this.setState({educator: {...this.state.educator, vat_valid: result.vat_valid, vat_validated_at: result.vat_validated_at},
                    vatOptions: vatOptions, vatValidationError: result.error_message})
            }, (error) => {
                this.setState({educator: {...this.state.educator, vat_valid: false, vat_validated_at: null},
                    vatOptions: vatOptions, vatValidationError: error})
            });
        }
    };

    onHandleChange = (e) => {
        let name = e.target.name;
        let educator = {...this.state.educator};
        educator[name] = ['receive_remarketing_emails', 'receive_summary_emails'].includes(name) ? e.target.checked : e.target.value;
        educator.errors[actions.camelize(name)] = "";
        let changingState = {};
        let needRevalidateVat = false;
        if (name === 'country_id') {
            const currentCountry = this.state.countries.find((c) => c.id === parseInt(educator.country_id));
            changingState['needValidateVat'] = (currentCountry && currentCountry.eu_vat);
            needRevalidateVat = !!educator.vat_number;
        }
        if (name === 'country_id' || name === 'vat_number') {
            educator['vat_valid'] = false;
            educator['vat_validated_at'] = null;
        }
        changingState['educator'] = educator;
        this.setState(changingState, () => {
            if (needRevalidateVat) {this.validateVat()}
        });
    };

    onChangeEmail = (email) => {
        this.setState({educator: {...this.state.educator, email: email}});
        this.changeEmailPopup.current.close();
        this.successPopup.current.open();
    };

    onChangePassword = () => {
        this.changePasswordPopup.current.close();
        this.successPopup.current.open();
    };

    onSuccess = () => {
        this.setState({isLoading: false});
        this.successPopup.current.open();
    };

    onError = (errors) => {
        this.setState({isLoading: false, educator: {...this.state.educator, errors: errors}}, () => {
            BaseFunc.scrollToError();
        });
    };

    onSubmit = () => {
        this.setState({isLoading: true}, () => {
            EducatorValidation.updateAccount(this.state.educator, () => {
                userAPI.update(this.state.educator, this.onSuccess, this.onError);
            }, this.onError);
        });
    };

    reset = (e) => {
        if (e) {e.preventDefault();}
        this.setState({educator: Object.assign({}, this.props.educator, {errors: {}})});
    };

    render() {
        let user = this.state.educator;
        return(
            <FadeInSection>
                <div className="grid-x align-center">
                    <div className="large-8 medium-12 small-12 cell">
                        <h1>Account Settings</h1>
                        <div className="grid-x">
                            <div className="cell">
                                <h3 className="license-checkout__inner__title">Your account</h3>
                            </div>

                            <div className={'cell medium-6 med-up-padR15'}>
                                <div className="input-link">
                                    <label>
                                        <span>Email address</span>
                                        <TextField name="email" value={user.email} disabled={true} />
                                        <a onClick={() => this.changeEmailPopup.current.open()}>Change email</a>
                                    </label>
                                </div>
                            </div>
                            <div className={'cell medium-6'}>
                                <label>
                                    <span>Full name</span>
                                    <TextField name="name" placeholder="Full Name*"
                                               errorMessage={user.errors.name}
                                               disabled={this.props.disabled}
                                               value={user.name} onChange={this.onHandleChange} />
                                </label>
                            </div>
                            <div className={'cell'}>
                                <div className="input-link">
                                    <label>
                                        <span>Password</span>
                                        <InputTypeField type="password" name="password" value={user.active ? '****************' : ''} disabled={true} />
                                        <a onClick={() => this.changePasswordPopup.current.open()}>Change password</a>
                                    </label>
                                </div>
                            </div>


                            <div className="cell">
                                <h3 className="license-checkout__inner__title">Billing Details</h3>
                            </div>

                            <div className={'cell'}>
                                <label>
                                    <span>Company/Institution Name</span>
                                    <TextField name="company_name" placeholder="Company/Institution Name*"
                                               errorMessage={user.errors.companyName}
                                               disabled={this.props.disabled}
                                               value={user.company_name} onChange={this.onHandleChange} />
                                </label>
                                <label>
                                    <span>Address</span>
                                    <TextField name="address" placeholder="Address*"
                                               errorMessage={user.errors.address}
                                               disabled={this.props.disabled}
                                               value={user.address} onChange={this.onHandleChange} />
                                </label>
                                <label>
                                    <span>Town/City</span>
                                    <TextField name="city" placeholder="Town/City*"
                                               errorMessage={user.errors.city}
                                               disabled={this.props.disabled}
                                               value={user.city} onChange={this.onHandleChange} />
                                </label>
                            </div>


                            <div className="medium-6 small-12 cell med-up-padR15">
                                <label>
                                    <span>Postal Code</span>
                                    <TextField name="postal_code" placeholder="Postal Code*"
                                               errorMessage={user.errors.postalCode}
                                               disabled={this.props.disabled}
                                               value={user.postal_code} onChange={this.onHandleChange} />
                                </label>
                            </div>

                            <div className="medium-6 small-12 cell">
                                <label>
                                    <span>Country</span>
                                    <SelectField name="country_id" placeholder="Country*"
                                                 className="label-icon-right select-label"
                                                 onChange={this.onHandleChange}
                                                 options={this.state.countries} optionsValue='id' optionsLabel='name'
                                                 selected={user.country_id} disabled={this.props.disabled}
                                                 errorMessage={user.errors.countryId} />
                                </label>
                            </div>

                            <div className={'cell'}>
                                <label>
                                    <span>Phone number</span>
                                    <InputTypeField type="tel" name="phone" placeholder="Phone number*"
                                                    errorMessage={user.errors.phone}
                                                    errorType="phone" disabled={this.props.disabled}
                                                    value={user.phone} onChange={this.onHandleChange} />
                                </label>
                                <label>
                                    <span>Tax/VAT number</span>
                                    <div className={`vat-container${this.state.needValidateVat && user.vat_valid ? ' vat-container--valid' : ''}${this.state.needValidateVat && !user.vat_valid ? ' vat-container--invalid' : ''}`}>
                                    <TextField name="vat_number" placeholder="Tax/VAT number*"
                                               errorMessage={user.errors.vatNumber} onBlur={this.validateVat}
                                               disabled={this.props.disabled}
                                               value={user.vat_number} onChange={this.onHandleChange} />
                                    </div>
                                    {this.state.vatValidationError ? <ErrorMessage message={this.state.vatValidationError} /> : null}
                                </label>
                            </div>
                        </div>
                        <label className="mar-top-20"><span>Email Notifications</span></label>
                        <div className="grid-x align-middle custom">
                            <div className="large-4  medium-6 cell">
                                <Checkbox name='receive_summary_emails' value={user.receive_summary_emails}
                                          onChange={this.onHandleChange} label='Receive a summary of users’ test progress' />
                            </div>
                            <div className="large-4 medium-6 cell">
                                <Checkbox name='receive_remarketing_emails' value={user.receive_remarketing_emails}
                                          onChange={this.onHandleChange} label='Receive promotional emails' />
                            </div>
                            <div className="large-4 medium-12 cell flex-end">
                                <HoverButton onClick={this.reset} className='cancel' color={'white'}>Cancel</HoverButton>
                                <HoverButton onClick={this.onSubmit} className={'save'}>Save</HoverButton>
                            </div>
                        </div>
                    </div>

                    <PopUp ref={this.changeEmailPopup}>
                        <EmailForm user={user} onSuccess={this.onChangeEmail} onCancel={() => this.changeEmailPopup.current.close()} />
                    </PopUp>
                    <PopUp ref={this.changePasswordPopup}>
                        <PasswordForm user={user} onSuccess={this.onChangePassword}
                                      onCancel={() => this.changePasswordPopup.current.close()}/>
                    </PopUp>
                    <PopUp ref={this.successPopup}>
                        <div className="grid-x align-center">
                            <div className="small-12 cell text-center">
                                <div className="popup__title popup__title--centered">
                                    <span className="small-icon checked"/>
                                    <h3>Changes saved</h3>
                                </div>
                            </div>
                        </div>
                    </PopUp>
                </div>
            </FadeInSection>
        )
    }

}

export default Form;